<template>
  <b-form-group
    :label="$t('fields.department')"
    label-for="id_departments"
  >
    <v-select
      v-model="dataItem.id_departments"
      :options="departmentsList"
      label="title"
      :reduce="item => item.id"
      :placeholder="$t('fields.selectDepartment')"
      clearable
      @input="onDepartmentChange"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ProjectsDepartmentsCard',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    departmentsList() {
      return this.$store.getters['departments/dataList']
    },
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    this.getDepartments()
  },
  methods: {
    getDepartments() {
      this.$store.dispatch('departments/getDataList', {
        select: [
          'departments.id AS id',
          'departments.title AS title',
        ],
        where: {
          'departments.status': 1,
        },
      })
    },
    onDepartmentChange() {
      this.$store.commit('projects/SET_DATA_ITEM', {
        ...this.dataItem,
        id_teams: null,
      })
      this.getTeams()
    },
    getTeams() {
      const where = { 'teams.status': 1 }
      if (this.dataItem.id_departments) {
        where['teams.id_departments'] = this.dataItem.id_departments
      }
      this.$store.dispatch('teams/getDataList', {
        select: [
          'teams.id AS id',
          'teams.title AS title',
        ],
        where,
        limit: 1000,
        start: 0,
      })
    },
  },
}
</script>
